export const GET_TRANSACTION_CONTACTS = (id: number) => `/workshop/transaction/${id}/contacts`;
export const CREATE_TRANSACTION_CONTACT = (id: number) => `/workshop/transaction/${id}/contacts`;
export const CREATE_TRANSACTION_CONTACT_PARTICIPANT = (id: number) =>
  `/workshop/transaction/${id}/contact-participant`;
export const UPDATE_TRANSACTION_CONTACT = (id: number, uuid: string) =>
  `/workshop/transaction/${id}/contacts/${uuid}`;
